import { SelectableBillingPeriodTypes } from '@constants/billingPeriods'
import { CurrencyType, PLN } from '@constants/currencies'
import { convertPriceToNetto } from '@helpers/payment'
import { Discount } from '@services/discounts'
import { Badge, Paragraph, Price, PriceDescription, Spacer } from '@ui-kit'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Column } from 'simple-flexbox'

import { AnnuallyLabel } from '../AnnuallyLabel'

interface PriceLabelProps {
  currency: CurrencyType
  price: number
  billingPeriod: SelectableBillingPeriodTypes
  annualSavingPrice: number
  isPLNCurrency: boolean
  isFreePlan?: boolean
  discount?: Discount
}

export const RegularPrice: FC<PriceLabelProps> = ({
  currency,
  price,
  billingPeriod,
  annualSavingPrice,
  isPLNCurrency,
  isFreePlan,
  discount
}) => {
  const { t } = useTranslation()

  const priceToView = discount
    ? price - convertPriceToNetto(discount.pricing)
    : price

  return (
    <Column>
      <Price amount={priceToView} currency={currency}>
        <PriceDescription>
          {isPLNCurrency && t('change.plan.page.net')}{' '}
          {t('change.plan.page.per.month')}
        </PriceDescription>
      </Price>

      {!discount ? (
        <AnnuallyLabel
          currency={currency}
          billingPeriod={billingPeriod}
          annualSavingPrice={annualSavingPrice}
          isPLNCurrency={isPLNCurrency}
          isFreePlan={isFreePlan}
        />
      ) : null}

      {discount ? (
        <div>
          <Paragraph size={14} color='neutral-6'>
            <del>
              {price.toFixed(2)} {currency}{' '}
              {isPLNCurrency && t('change.plan.page.net')}
            </del>
          </Paragraph>

          <Spacer space={5} />

          <Badge variant='info20-filled' weight={600} isTextUppercase={false}>
            {t('change.plan.page.special.discount')} {discount.pricing}{' '}
            {currency}{' '}
            {currency === PLN && t('registration.flow.credit.card.step.gross')}
          </Badge>

          <Spacer space={20} />
        </div>
      ) : null}
    </Column>
  )
}

RegularPrice.displayName = 'CheckoutPlansPlanPanelsPlanPriceLabelRegularPrice'
